import { ITab } from "../../../utils/interfaces";

export const TabItems: Array<ITab> = [
    {
        id: 0,
        label: "Login",
        src: "/login",
        visible: true,
    },
    {
        id: 1,
        label: "Sign Up",
        src: "/signUp",
        visible: true
    },
    {
        id: 2,
        label: "Sign Out",
        src: "/login",
        visible: false
    }
];
